import { render, staticRenderFns } from "./ConfirmCollection.vue?vue&type=template&id=edc210ac&scoped=true"
import script from "./ConfirmCollection.vue?vue&type=script&lang=js"
export * from "./ConfirmCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc210ac",
  null
  
)

export default component.exports